import { psaInitialFormData } from "@/utils/enum";
import { createSlice } from "@reduxjs/toolkit";

export interface VafpFilterState {
  schools: any;
  grades: any;
  boardId: any;
  currentPage: any;
  vafpEventsCount: any;
  vafpEvents: [];
  vafpSearchData: any;
  studentId: any;
  dob: any;
  gender: any;
  enrollmentNumber: any;
  firstName: any;
  lastName: any;
  email: any;
  phoneNumber: any;
  studentType: any;
  schoolName: any;
}

const initialState: VafpFilterState = {
  schools: null,
  grades: null,
  boardId: "",
  dob: "",
  gender: "",
  enrollmentNumber: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  studentType: "",
  schoolName: "",
  studentId: "",
  currentPage: 1,
  vafpEventsCount: 0,
  vafpEvents: [],
  vafpSearchData: { ...psaInitialFormData },
};

const vafpFilterSlice = createSlice({
  name: "vafpFilter",
  initialState,
  reducers: {
    addFilter: (state, action) => {
      return { ...state, ...action.payload };
    },
    setVafpEventsCount: (state, action) => {
      state.vafpEventsCount = action.payload;
    },
    setVafpEvents: (state, action) => {
      state.vafpEvents = action.payload;
    },
    setVafpSearchData: (state, action) => {
      state.vafpSearchData = action.payload;
    },
    clearVafpData: (state) => {
      return {
        ...initialState,
      };
    },
    clearVafpFilters: (state) => {
      state.schools = null;
      state.grades = null;
      state.boardId = "";
      state.dob = "";
      state.gender = "";
      state.enrollmentNumber = "";
      state.firstName = "";
      state.lastName = "";
      state.email = "";
      state.phoneNumber = "";
      state.studentType = "";
      state.schoolName = "";
      state.vafpEvents = [];
      state.studentId = "";
    },
  },
});

export const {
  addFilter,
  setVafpEventsCount,
  setVafpEvents,
  setVafpSearchData,
  clearVafpData,
  clearVafpFilters,
} = vafpFilterSlice.actions;
export const vafpFilterItems = (state: any) => state.vafpFilter;
export default vafpFilterSlice.reducer;
